import { useEffect, useState } from "react";
import { createPublicClient, http } from 'viem'
import { polygon } from 'viem/chains'
import { Chain, Chains, RewardEventABI } from "../data"
import { Table } from "antd";
import { getJicAddress, onJicChange } from "../../lib/jic";
// import "./reward.css"
type Data = {
    key: string,
    token: string,
    value: string,
    time: string,
    block: string,
    transaction: string,
}
const infuraURL = 'https://polygon-mainnet.infura.io/v3/5122ede25a7c4fc0bace3b8690f1aaf7'

const scanURL = "https://polygonscan.com/tx/"

const usdDecimals = 1n

const formatRewardTime = (timestamp: bigint) => {
    return new Intl.DateTimeFormat("zh-CN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    }).format(new Date(Number(timestamp) * 1000))
}

const shortHash = (hash: string) => {
    if (!hash) return ""
    return hash.slice(0, 10) + "..." + hash.slice(-8)
}

const RewardHistory = () => {
    const [data, setData] = useState([] as Data[])
    const [total, setTotal] = useState(0)
    const [address, setAddress] = useState<string | null>(() => getJicAddress());
    const publicClient = createPublicClient({
        chain: polygon,
        transport: http(infuraURL),
    })

    const getRewardEvent = async () => {
        if (!address) {
            setData([])
            setTotal(0)
            return
        }
        const targetAddress = address.toLowerCase()
        const logs = await publicClient.getContractEvents({
            abi: RewardEventABI,
            address: Chains[Chain.POL].contractAddr as `0x${string}`,
            eventName: 'Reward',
            fromBlock: 67083032n,
            toBlock: 167083032n
        })
        // console.log(logs)
        // console.log((logs[0] as any).args)
        const rewardLogs = logs
            .filter((l: any) => {
                return (l.args.to || "").toLowerCase() === targetAddress
            })
            .sort((a: any, b: any) => {
                if (a.blockNumber === b.blockNumber) {
                    const aLogIndex = BigInt(a.logIndex ?? 0)
                    const bLogIndex = BigInt(b.logIndex ?? 0)
                    return aLogIndex < bLogIndex ? 1 : aLogIndex > bLogIndex ? -1 : 0
                }
                return a.blockNumber < b.blockNumber ? 1 : -1
            })
        const blockTimes = new Map<string, string>()
        await Promise.all(
            Array.from(new Set(rewardLogs.map((l: any) => l.blockNumber.toString()))).map(async (blockNumber) => {
                const block = await publicClient.getBlock({ blockNumber: BigInt(blockNumber) })
                blockTimes.set(blockNumber, formatRewardTime(block.timestamp))
            })
        )
        const data: Data[] = []
        var _total = 0;
        rewardLogs.forEach((l: any) => {
            const blockNumber = l.blockNumber.toString()
            const rewardAmount = Number(Number(l.args.value * 100n / usdDecimals) / 100)
            _total += rewardAmount
            // console.log(l.args.value)
            // console.log(l.args.value.toString())
            // console.log(l.blockNumber.toString())
            data.push({
                key: l.transactionHash,
                token: 'SATs(WBTC)',
                value: (rewardAmount).toString(),
                time: blockTimes.get(blockNumber) || "",
                block: blockNumber,
                transaction: l.transactionHash
            })

        })
        setData(data)
        setTotal(_total)
    }
    useEffect(
        () =>
            onJicChange((user) => {
                setAddress(user?.sub ? user.sub.toLowerCase() : null);
            }),
        []
    );
    useEffect(() => {
        getRewardEvent();
        // eslint-disable-next-line
    }, [address])
    const colmun = [
        {
            title: 'Token',
            dataIndex: 'token',
            key: 'token',
        },
        {
            title: 'Value',
            dataIndex: 'value',
            key: 'value',
        },
        {
            title: 'Time',
            dataIndex: 'time',
            key: 'time',
        },
        {
            title: 'Block',
            dataIndex: 'block',
            key: 'block',
        },
        {
            title: 'Transaction',
            dataIndex: 'transaction',
            key: 'transaction',
            render: ((record: any) => {
                return <a rel="noreferrer" href={scanURL + record} target="_blank">{record}</a>
            })
        }
    ]
    return (
        <div className="flex h-full w-full flex-col items-center gap-4 overflow-y-auto px-4 pb-28 pt-24 md:justify-center md:px-10 md:py-10">
            <p className="font-Armstrong text-white text-center text-lg md:text-xl">Total rewards: {total} SATs</p>
            <div className="hidden w-full max-w-6xl md:block">
                <Table columns={colmun} dataSource={data} className="w-full" scroll={{ x: true }} />
            </div>
            <div className="flex w-full flex-col gap-3 md:hidden">
                {data.length === 0 && (
                    <div className="rounded-lg bg-white/95 px-4 py-5 text-center text-sm font-semibold text-[#222] shadow-lg">
                        No rewards yet
                    </div>
                )}
                {data.map((item) => (
                    <div key={item.key} className="rounded-lg bg-white/95 p-4 text-[#222] shadow-lg">
                        <div className="mb-3 flex items-start justify-between gap-3 border-b border-black/10 pb-3">
                            <div>
                                <p className="text-xs font-semibold uppercase tracking-wide text-black/45">Token</p>
                                <p className="text-lg font-bold">{item.token}</p>
                            </div>
                            <div className="text-right">
                                <p className="text-xs font-semibold uppercase tracking-wide text-black/45">Value</p>
                                <p className="text-lg font-bold">{item.value}</p>
                            </div>
                        </div>
                        <div className="grid grid-cols-[5rem_1fr] gap-y-2 text-sm">
                            <span className="font-semibold text-black/45">Time</span>
                            <span className="text-right font-medium">{item.time}</span>
                            <span className="font-semibold text-black/45">Block</span>
                            <span className="text-right font-medium">{item.block}</span>
                            <span className="font-semibold text-black/45">Tx</span>
                            <a
                                rel="noreferrer"
                                href={scanURL + item.transaction}
                                target="_blank"
                                className="break-all text-right font-semibold text-blue-600"
                            >
                                {shortHash(item.transaction)}
                            </a>
                        </div>
                    </div>
                ))}
            </div>
            {/* <button onClick={getTransferEvent}>get transfer event</button> */}
            {/* <button onClick={getRewardEvent}>get reward event</button> */}
        </div>
    )
}
export default RewardHistory;
